import React from 'react'
import MainLayout from '../layouts/main-layout'
import SEO from '../components/seo'
import ContactDetails from '../components/contact-details'
import Button from '../components/button'
import { P } from '../components/typography'
import { Div } from '../components/contact'

const ContactPage = () => (
  <MainLayout titleText="Contact Us">
    <SEO title="Contact Us" />

    <Div>
      <P centered>To book direct, click the button below.</P>
      <Button primary large text="Book Direct" href="https://direct-book.com/properties/chesterlodgehoteldirect" target="_blank" rel="noopener noreferrer" />
    </Div>

    <Div>
      <P centered>For booking enquiries, you can contact us by phone or email.</P>
      <ContactDetails />
    </Div>
  </MainLayout>
)

export default ContactPage
